'use client';

import React from 'react';
import { Loader2 } from 'lucide-react';
import { useDevice } from '@/app/lib/contexts/DeviceContext';
import DesktopDiscoverCharacters from './desktop/DesktopDiscover';
import MobileDiscoverCharacters from './mobile/MobileDiscover';
import type { Character } from '@/app/lib/types/character';
import type { CloudinaryPreloadResult } from '@/app/lib/cloudinary/cloudinary-preload';

interface ResponsiveDiscoverWrapperProps {
  initialAvatars: {
    success: boolean;
    avatars: Character[] | null;
    message: string;
    hasMore: boolean;
  };
  cloudinaryPreload: CloudinaryPreloadResult | null;
}

export default function ResponsiveDiscoverWrapper({ initialAvatars, cloudinaryPreload }: ResponsiveDiscoverWrapperProps) {
  const { isMobile, isDesktop } = useDevice();

  // Don't render anything until device detection is complete
  if (!isMobile && !isDesktop) {
    return (
      <div className="flex flex-col items-center gap-6 p-6 bg-[#121214]">
        <h1 className="sr-only">Discover AI Characters - Dango Chat</h1>
        <Loader2 className="w-12 h-12 animate-spin text-white" />
        <p className="text-white">Loading...</p>
      </div>
    );
  }

  // Render appropriate component based on device
  return (
    <>
      <h1 className="sr-only">Discover AI Characters - Dango Chat</h1>
      {isDesktop && <DesktopDiscoverCharacters initialAvatars={initialAvatars} cloudinaryPreload={cloudinaryPreload} />}
      {isMobile && <MobileDiscoverCharacters initialAvatars={initialAvatars} cloudinaryPreload={cloudinaryPreload} />}
    </>
  );
} 